import { useEffect } from 'react';
import { parseCookies } from 'nookies';

const zendeskLanguageMap = {
  fr: 'fr',
  en: 'en-US',
  es: 'es',
};

const useWidgetScript = (url, id, languagePreference, clientId) => {
  useEffect(() => {
    if (clientId === 'g361-monsieur-store' || clientId === 'amplifon') {
      return;
    }

    const { 'next-i18next': lang } = parseCookies();
    const script = document.createElement('script');

    script.src = url;
    script.id = id;
    if (lang || languagePreference) {
      script.onload = () =>
        window?.zE?.('webWidget', 'setLocale', zendeskLanguageMap[lang || languagePreference]);
    }

    document.body.appendChild(script);

    return () => document.body.removeChild(script);
  }, [url, id, languagePreference, clientId]);
};

export default useWidgetScript;
